import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import { ConciergeRoutingChain, ConciergeSummary } from './_conciergeModels'

const base = (token: string) => `${API_URL}/api/internal/payment/${token}/concierge`

const data = async <T>(request: Promise<{ data: ApiResponse<T> }>): Promise<ApiResponse<T>> => (await request).data

export const getConcierge = (token: string) => data(axios.get<ApiResponse<ConciergeSummary>>(base(token)))

export const updateConcierge = (token: string, body: { paymentMethod?: string; amount?: number }) =>
  data(axios.patch<ApiResponse<ConciergeSummary>>(base(token), body))

export const getConciergeRouting = (token: string, paymentMethod: string) =>
  data(axios.get<ApiResponse<{ chain: ConciergeRoutingChain | null }>>(`${base(token)}/routing`, { params: { paymentMethod } }))

export const searchConcierge = (token: string, excludedAdapterIds: number[]) =>
  data(axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/search`, { excludedAdapterIds }))

export const selectConciergeVariant = (token: string, variantId: number) =>
  data(axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/variant`, { variantId }))

export const cancelConciergeIssuance = (token: string) =>
  data(axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/cancel-issuance`, {}))

export const extendConcierge = (token: string, minutes: number) =>
  data(axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/extend`, { minutes }))

/** `amount` is left out when the adapter confirmed the payment itself: the backend takes its amount. */
export const lateCreditConcierge = (token: string, externalTransactionId: number, amount: number | null) =>
  data(
    axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/late-credit`, amount === null ? { externalTransactionId } : { externalTransactionId, amount })
  )

export const expireConcierge = (token: string) =>
  data(axios.post<ApiResponse<ConciergeSummary>>(`${base(token)}/expire`, {}))
